import { useContext, useMemo } from 'react';
import { ColorModeContext } from '../../../App';
import { getSemanticColors } from '../theme';

/**
 * Hook to get the current theme mode and semantic colors
 * Returns the current mode, semantic colors for that mode, toggle function, and transition state
 */
export const useThemeMode = () => {
  const { mode, toggleColorMode, isTransitioning } = useContext(ColorModeContext);

  const semanticColors = useMemo(() => getSemanticColors(mode), [mode]);

  return {
    mode,
    semanticColors,
    toggleColorMode,
    isDarkMode: mode === 'dark',
    isTransitioning,
  };
};
